import { DestroyRef, inject } from '@angular/core';
import { CommandPaletteService, CommandPaletteSettings } from './command.palette.service';

export function useCommandPalette(settings: CommandPaletteSettings): () => void {

  const palette = inject(CommandPaletteService);
  const destroyRef = inject(DestroyRef);
  return palette.setCommandK(settings, destroyRef);
}
